import moment from 'moment';

import './selected-date-range.style.sass';
import template from './selected-date-range.tpl.pug';

class SelectedDateRangeController {
    $onChanges(changeObject) {
        if (changeObject.start) {
            this.startDate = this.formatPeriodDate(this.start, 'Beginning of time');
        }
        
        if (changeObject.start) {
            this.endDate = this.formatPeriodDate(this.end, 'End of time');
        }
    }

    formatPeriodDate(date, placeholder) {
        date = date
            ? moment(date)
            : null;

        return date && date.isValid()
            ? date.format('MMMM D, YYYY')
            : placeholder;
    }
}

export default {
    selector: 'dbASelectedDateRange',
    template: template(),
    controller: SelectedDateRangeController,
    bindings: {
        start: '<',
        end: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/dashboard/component/selected-date-range/selected-date-range.cmpt.js